//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isElectron } from '@/utils/constants';

let resizeTimeout;
export default {
  props: {
    cata_name: {
      type: String,
      default: '全部',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    catalogs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      showRight: false,
      showLeft: false,
      isClient: isElectron(),
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.chargeScroll();
    });
    window.addEventListener('resize', this.resizeThrottler, false);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeThrottler);
  },
  methods: {
    resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          this.chargeScroll();
          this.$emit('window-change');
        }, 66);
      }
    },
    jumpPlugin() {
      this.$router.push({
        path: '/plugin',
      });
    },
    changeType(cata_name) {
      this.$emit('changeType', cata_name);
    },
    search(searchVal) {
      this.$emit('search', searchVal);
    },
    handleScroll() {
      this.chargeScroll();
    },
    chargeScroll() {
      const el = this.$refs.filter;
      const scrollbarWidth = el.scrollWidth - el.clientWidth;
      const offsetRight = 1;
      this.showRight = scrollbarWidth && el.scrollLeft + offsetRight < scrollbarWidth;
      this.showLeft = scrollbarWidth && el.scrollLeft > 0;
    },
    navLeftClick() {
      this.scrollSmoothTo(0);
    },
    navRightClick() {
      const el = this.$refs.filter;
      const scrollbarWidth = el.scrollWidth - el.clientWidth;
      this.scrollSmoothTo(scrollbarWidth);
    },
    scrollSmoothTo(position) {
      const el = this.$refs.filter;
      el.scrollTo({ left: position });
    },
    scrollShow() {
      const el = this.$refs.filter;
      const curElId = this.$route.query?.cata_name
      const dom = document.getElementById(curElId)
      if (el && dom) {
        const clientWidth = el.clientWidth;
        const domWidth = dom.clientWidth;
        const domOffsetLeft = dom.offsetLeft || 0
        const range = 26
        if(el.scrollLeft > domOffsetLeft || el.scrollLeft + clientWidth < domOffsetLeft + domWidth) el.scrollLeft = domOffsetLeft && (domOffsetLeft - range)
      }
    }
  },
};
